/**
 * When a tag has no stored color, pick a deterministic default from the app color scheme (same palette as projects).
 */
export function resolveTagDisplayColor(
	color: string | null | undefined,
	tagId: string,
	getColorFromScheme: (rnd?: number) => string
): string {
	if (color) return color;
	let h = 0;
	for (let i = 0; i < tagId.length; i++) {
		h = (Math.imul(31, h) + tagId.charCodeAt(i)) | 0;
	}
	return getColorFromScheme(Math.abs(h) || 1);
}

import { APP_ASSIGN_COLOR_SCHEME } from "@app/shared/color-schemes/office-scheme";

export function normalizeHexColor(color: string | null | undefined): string | null {
	const raw = (color ?? "").trim();
	if (!raw) return null;
	const m = raw.match(/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/);
	if (!m?.[1]) return null;
	let hex = m[1].toLowerCase();
	if (hex.length === 3) {
		hex = hex
			.split("")
			.map((c) => c + c)
			.join("");
	}
	return `#${hex}`;
}

export function isValidHexColor(color: string | null | undefined): boolean {
	return !!normalizeHexColor(color);
}

function hashStringToInt(input: string): number {
	// stable, non-crypto hash (djb2 variant)
	let h = 5381;
	for (let i = 0; i < input.length; i++) {
		h = (h * 33) ^ input.charCodeAt(i);
	}
	return h >>> 0; // uint32
}

export function deterministicTagColor(seed: string | null | undefined): string {
	const s = (seed ?? "").trim().toLowerCase();
	const idx = (s ? hashStringToInt(s) : 1) % APP_ASSIGN_COLOR_SCHEME.length;
	return normalizeHexColor(APP_ASSIGN_COLOR_SCHEME[idx]) ?? "#5b9bd5";
}
